import { Stack, styled } from '@mui/material';

export const ExternalRow = styled(Stack, { target: 'Ds-Table-ExternalRow' })({
  flexDirection: 'row',
  position: 'relative',
  alignItems: 'center',
});
